function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// FilterDropdown.jsx
import React from "react";
class FilterDropdown extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "setContainerRef", node => {
      this.containerRef = node;
    });
    _defineProperty(this, "handleDocumentClick", e => {
      if (!this.containerRef) return;
      if (this.containerRef.contains(e.target)) return;
      if (this.state.open) {
        this.setState({
          open: false
        });
      }
    });
    _defineProperty(this, "toggleOpen", () => {
      this.setState(prev => ({
        open: !prev.open
      }));
    });
    _defineProperty(this, "close", () => {
      this.setState({
        open: false
      });
    });
    this.state = {
      open: false
    };
    this.containerRef = null;
  }
  componentDidMount() {
    if (typeof document !== "undefined") {
      document.addEventListener("click", this.handleDocumentClick, true);
    }
  }
  componentWillUnmount() {
    if (typeof document !== "undefined") {
      document.removeEventListener("click", this.handleDocumentClick, true);
    }
  }
  render() {
    const {
      open
    } = this.state;
    const {
      label,
      children
    } = this.props;
    let cls = "ff-filter__menu";
    if (label === "Sort By") {
      cls += " sort-menu";
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "ff-filter",
      ref: this.setContainerRef
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ff-filter__trigger",
      onClick: this.toggleOpen
    }, /*#__PURE__*/React.createElement("span", {
      className: "ff-filter__label"
    }, label), /*#__PURE__*/React.createElement("img", {
      src: "/images/icons/dropdown-arrow.png",
      alt: "",
      className: "ff-filter__icon" + (open ? " ff-filter__icon--open" : "")
    })), open && /*#__PURE__*/React.createElement("div", {
      className: cls
    }, typeof children === "function" ? children({
      close: this.close
    }) : children));
  }
}
export default FilterDropdown;